// extracted by mini-css-extract-plugin
export default {"formField":"Aqa-z","error":"Bqa-z","disabled":"Cqa-z","fieldError":"Dqa-z","errorText":"Eqa-z","button":"Fqa-z","acknowledgment":"Gqa-z"};